import { Check } from "lucide-react";

const SOVEREIGNTY_POINTS = [
  "Stronger Personal Brand (Your own branded URL)",
  "Exclusive Signals (Zero shared leads)",
  "Institutional Conversion (AI-backed trust)",
  "Escape PPL Dependency (No more pay-per-lead)",
  "Sovereign Traffic (Owned, not borrowed)",
  "Positioning Control (You define your authority)",
  "Direct Signal Quality (Direct to WhatsApp)",
  "Built-in Conversion Funnels (Closing-first logic)",
  "SEO Legacy (Long-term organic growth)",
  "Operational Efficiency (Cost-effective scaling)",
  "Centralized System (One command center)",
  "Elite Client Trust (Institutional credibility)",
];

export const LeadSovereigntyCard = ({ onSeatCheckoutStart, className = "" }) => {
  return (
    <div className={`rounded-[30px] bg-[linear-gradient(135deg,rgba(212,175,55,0.28)_0%,rgba(212,175,55,0.08)_38%,rgba(255,255,255,0.06)_100%)] p-[1px] shadow-[0_22px_60px_rgba(0,0,0,0.2)] ${className}`.trim()} data-testid="lead-sovereignty-card-shell">
      <div className="flex h-full flex-col rounded-[29px] border border-white/6 bg-[linear-gradient(135deg,rgba(3,26,52,0.88)_0%,rgba(13,35,61,0.84)_100%)] p-5 backdrop-blur-xl lg:p-6" data-testid="lead-sovereignty-card">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="lead-sovereignty-kicker">Lead Sovereignty</p>
        <h3 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-tight text-[#D4AF37]" data-testid="lead-sovereignty-heading">Stop Buying Leads. Start Owning Them.</h3>
        <p className="mt-3 text-sm leading-7 text-[#E6DCC4]" data-testid="lead-sovereignty-subheading">Transition from rented dependency to institutional ownership.</p>

        <div className="mt-6 grid gap-3 sm:grid-cols-2" data-testid="lead-sovereignty-grid">
          {SOVEREIGNTY_POINTS.map((point, index) => (
            <div className="rounded-[20px] border border-[#D4AF37]/12 bg-[rgba(255,255,255,0.04)] px-4 py-4" data-testid={`lead-sovereignty-point-${index + 1}`} key={point}>
              <div className="flex items-start gap-3">
                <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/20 bg-[rgba(212,175,55,0.14)] text-[#D4AF37]">
                  <Check className="h-3.5 w-3.5" />
                </div>
                <p className="text-sm leading-6 text-[#F8F3E8]">{point}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 rounded-[22px] border border-[#D4AF37]/14 bg-[rgba(255,255,255,0.03)] px-4 py-5 lg:mt-auto" data-testid="lead-sovereignty-hook-card">
          <p className="text-sm font-semibold leading-7 text-[#F8F3E8]" data-testid="lead-sovereignty-hook-text">👉 Stop being a lead buyer. 👉 Start becoming a lead owner.</p>
          <button className="gold-button mt-4 inline-flex" data-testid="lead-sovereignty-cta-button" onClick={onSeatCheckoutStart} type="button">
            Claim Your Founding Seat
          </button>
        </div>
      </div>
    </div>
  );
};